var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasedOnLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    viewBox: "0 0 109 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BasedOnLogo",
    transform: "translate(-29 -11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-530.41 -310.421)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 7.907,
    height: 29.753,
    transform: "translate(559.411 321.421)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 6.634,
    cy: 6.634,
    r: 6.634,
    transform: "translate(569.328 322.359)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 6.634,
    cy: 6.634,
    r: 6.634,
    transform: "translate(569.328 337.906)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 6.634,
    cy: 6.634,
    r: 6.634,
    transform: "translate(585.143 337.906)",
    fill: "#0f0f0f"
  })), /*#__PURE__*/React.createElement("text", {
    id: "basedon",
    transform: "translate(76 39)",
    fill: "#0f0f0f",
    fontSize: 12,
    fontFamily: "Rubik-Bold, Rubik",
    letterSpacing: "0.05em",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BASED"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Rubik-Regular, Rubik",
    fontWeight: 400
  }, "ON")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasedOnLogo);
export default __webpack_public_path__ + "static/media/BasedOnLogo.4cd411bd8e86bf35edaf048c0a225315.svg";
export { ForwardRef as ReactComponent };